import React from 'react'

import { StyledLogo } from '../styled'

const Logo = () => <StyledLogo strong>Menu Curator - FoodStyles</StyledLogo>
export default Logo
